<!--
     <ActionNavigate
       size='small'
       :unit="QUnit"
     />
-->

<template>
  <div class="vcenter">
    <v-icon 
      small
      class="mr-2"
      :color="color"
      @click="goto_qunit"
      :disabled="disabled"
    >
      mdi-arrow-right
    </v-icon>
  </div>
</template>


<script>
import Navegation from '@/utils/Navegation';

export default {
  name: "ActionNavigate",

  props: {
    size: { default: 'small' },
    unit: { required: true },
    color: {},
    disabled: Boolean
  },

  methods: {
    goto_qunit() {
      Navegation.goto_qunit(this.$router, this.unit);
    }
  },
};
</script>
